import { FAQS } from 'constants/api'
import useAxios from 'axios-hooks'
import Button from 'components/button'
import Input from 'components/input'
import LoadingScreen from 'components/loading-screen'
import { useRef } from 'react'
import Collapsible from 'react-collapsible'
import useRouter from 'hooks/use-router'
import ErrorView from 'components/error-view'
import { useSession } from '../../contexts/session-context'
import { DivTextHelp, AreaTextHelp, DivBgHelp } from '../../theme/help'
import style from './help.module.scss'

const Help = () => {
  const session = useSession()
  const [{ loading: loadingFaqs, error: errorFaqs, data: faqs }] = useAxios({ url: FAQS })
  const { history } = useRouter()
  const [{ user, data = {} as any }] = session
  const { phoneNumber } = user || {}
  const { idToken } = data._tokenResponse || {}
  if (!idToken) {
    window.location.href = process.env.PUBLIC_URL
    return
  }
  const [{ response, loading, error }, fetch] = useAxios(
    {
      method: 'POST',
      url: 'https://' + API_BASE_USER_UPDATE + '/promohub/api/v1/profiles/send/contact',
      headers: { Authorization: `Bearer ${idToken}` }
    },
    { manual: true }
  )

  const phoneRef = useRef<HTMLInputElement>(null)
  const textRef = useRef<HTMLTextAreaElement>(null)

  const submitHandler = async (e: any) => {
    e.preventDefault()
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'HELP - Contactanos', value: '10' })
    const data = {
      phoneNumber: phoneRef.current?.value,
      message: textRef.current?.value
    }

    if (!phoneRef.current?.value) {
      alert('se deben completar ambos campos')
    }

    if (!textRef.current?.value) {
      alert('se deben completar ambos campos')
    }

    await fetch({ data })
  }

  const messageSuccess = !(error && loading) && !!response

  if (messageSuccess) {
    // Cambiar nombre de componente
    return (
      <ErrorView buttonMenu={() => history.push('/home')} code={901} />
    )
  }

  if (errorFaqs || error) {
    return <ErrorView buttonMenu={() => history.push('/home')} code={9999} />
  }

  if (loadingFaqs || loading) {
    return <LoadingScreen />
  }

  return (
    <section className="flex flex-col w-full p-7 pb-0 sm:p-0 items-center">
      <DivTextHelp className="space-y-4 pb-2">
        <h1 className="uppercase text-3xl text-center font-bold"> ¿tienes algún problema?</h1>
        <p className="din uppercase text-center">
          Revisa primero en nuestras preguntas frecuentes, si no encuentras la respuesta, contáctanos.
        </p>
        <div>
          {faqs.map((faq: any) => (
            <div className={style.collapsible} key={faq.title}>
              <Collapsible trigger={faq.title}>
                <p dangerouslySetInnerHTML={{ __html: faq.content }}></p>
              </Collapsible>
            </div>
          ))}
        </div>
      </DivTextHelp>
      <DivBgHelp className="w-screen flex-1 flex justify-center pt-4 min-h-screen p-7">
        <div className="flex flex-col w-full sm:max-w-sm space-y-6">
          <h1 className="uppercase text-3xl text-center font-bold pt-2"> ¿más dudas?</h1>
          <p className="din uppercase text-center">No te preocupes, déjanos un mensaje para solucionarlo.</p>
          <form className="flex flex-1 flex-col space-y-4" onSubmit={submitHandler}>
            <Input
              type="tel"
              placeholder="Ingresa tu teléfono"
              className="text-center din text-sm font-bold"
              ref={phoneRef}
              defaultValue={phoneNumber}
              maxLength={13}
              required
            />
            <AreaTextHelp
              ref={textRef}
              className="flex-1 uppercase din text-sm font-bold p-4 focus:outline-none "
              placeholder=" Dinos, ¿para qué somos buenos?"
              required
            ></AreaTextHelp>
            <Button>ENVIAR MENSAJE</Button>
          </form>
        </div>
      </DivBgHelp>
    </section>
  )
}

export default Help
